import { type PropsWithChildren } from 'react';
import { RiErrorWarningFill } from 'react-icons/ri';

import { useDate } from '../../../utility/useDate';
import { useTranslation } from 'react-i18next';

interface ILocationNodeData {
    blockPark: boolean,
    earliestCheckoutDate: string,
    displayMixedLaneWarning: boolean,
    displayNextMovementDate: boolean,
    isMixedLane: boolean,
}

const LocationNodeDataDisplay = (props: PropsWithChildren<ILocationNodeData>) => {
    const formatDate = useDate().toFormattedDateString;
    const { t } = useTranslation();

    return (<div style={{ display: 'flex' }}>
        {props.displayMixedLaneWarning && props.isMixedLane && props.blockPark ? <RiErrorWarningFill title={t("treeView.mixedLane")} style={{ height: "1.3em", width: "3em", marginLeft: -12, marginRight: -5 }} /> : null}
        {props.displayNextMovementDate && props.earliestCheckoutDate && !props.children && <div style={{ paddingRight: 10 }}>
            {formatDate(props.earliestCheckoutDate)}
        </div>}
    </div>);
}

export default LocationNodeDataDisplay;

